const fr = {
  "navbar.notifications": "Notifications",
  "navbar.noNotifications": "Aucune nouvelle notification",
  "navbar.cookieSettings": "Paramètres des cookies",
  "nav.logout": "Se déconnecter",
  "nav.language": "Langue",
  "nav.english": "Anglais (US)",
  "nav.french": "Français (FR)",

  "sidebar.navigation": "Navigation",
  "sidebar.mainDashboard": "Tableau de bord principal",
  "sidebar.home": "Accueil",
  "sidebar.customers": "Clients",
  "sidebar.billing": "Facturation",
  "sidebar.referral": "Parrainage",
  "sidebar.googleReviews": "Avis Google",
  "sidebar.flashDeals": "Offres éclair",
  "sidebar.loyaltyProgram": "Programme de fidélité",
  "sidebar.analyticsInsights": "Analytique et perspectives",
  "sidebar.transactionsPurchases": "Transactions et achats",
  "sidebar.merchantApprovals": "Approbations des commerçants",
  "sidebar.adminKpis": "KPI entreprise",
  "sidebar.squareMerchants": "Commerçants Square & Commandes",
  "sidebar.customerLoyalty": "Fidélité des clients",
  "sidebar.pendingRewards": "Récompenses en attente",
  "sidebar.loyaltySettings": "Paramètres de fidélité",
  "sidebar.users": "Utilisateurs",
  "sidebar.inactiveUsers": "Utilisateurs inactifs",
  "sidebar.usersList": "Liste des utilisateurs",
  "sidebar.profile": "Profil",
  "sidebar.businesses": "Entreprises",
  "sidebar.clients": "Clients",
  "sidebar.items": "Articles",
  "sidebar.itemsPurchased": "Articles achetés",
  "sidebar.purchaseHistory": "Historique des achats",
  "sidebar.receiptsHistory": "Historique des reçus",
  "sidebar.churnRate": "Taux d’attrition",
  "sidebar.itemsOverview": "Aperçu des articles",
  "sidebar.netPromoterScore": "Score Net Promoter",
  "sidebar.increasedMarginChart": "Graphique de marge accrue",
  "sidebar.repeatPurchase": "Achats répétés",
  "sidebar.revenueGraph": "Graphique des revenus",

  "dashboard.dashboard": "Tableau de bord",
  "dashboard.customers": "Clients",
  "dashboard.customers.compareMessage": "Depuis le mois dernier",
  "dashboard.orders": "Commandes",
  "dashboard.revenue": "Revenus",
  "dashboard.growth": "Croissance",
  "dashboard.HighPerformingProducts": "Produits à Haute Performance",
  "dashboard.Sales": "Ventes",

  "merchantsData.title": "Commerçants Square & Commandes",
  "merchantsData.merchantsList": "Liste des commerçants",
  "merchantsData.selectMerchant": "Sélectionner un commerçant",
  "merchantsData.payments": "Paiements",
  "merchantsData.viewDetails":
    "Sélectionnez un commerçant pour voir les détails",
  "merchantsData.notFound": "Aucun commerçant trouvé",
  "merchantsData.noSquareMerchant":
    "Aucun compte commerçant Square lié. Veuillez utiliser « Se connecter avec Square » sur le tableau de bord pour connecter votre compte.",

  "merchantsData.merchantDetail.id": "ID du commerçant",
  "merchantsData.merchantDetail.country": "Pays",
  "merchantsData.merchantDetail.currency": "Devise",
  "merchantsData.merchantDetail.statistics": "Statistiques :",
  "merchantsData.merchantDetail.totalPayments": "Total des paiements",
  "merchantsData.merchantDetail.totalOrders": "Total des commandes",
  "merchantsData.merchantDetail.user": "Utilisateur",
  "merchantsData.merchantDetail.paymentId": "ID de paiement :",
  "merchantsData.merchantDetail.amount": "Montant :",
  "merchantsData.merchantDetail.status": "Statut :",
  "merchantsData.merchantDetail.nopaymentsfound": "Aucun paiement trouvé",
  "merchantsData.merchantDetail.orderId": "ID de commande :",
  "merchantsData.merchantDetail.items": "articles",
  "merchantsData.merchantDetail.noOrdersfound": "Aucune commande trouvée",

  "merchantsData.paymentDetail.header": "Détails du paiement",
  "merchantsData.paymentDetail.paymentID": "ID de paiement",
  "merchantsData.paymentDetail.orderID": "ID de commande",
  "merchantsData.paymentDetail.status": "Statut",
  "merchantsData.paymentDetail.tip": "Pourboire",
  "merchantsData.paymentDetail.Total": "Total",
  "merchantsData.paymentDetail.refunded": "Remboursé",
  "merchantsData.paymentDetail.card": "Carte",
  "merchantsData.paymentDetail.customerID": "ID client",
  "merchantsData.paymentDetail.email": "Email",
  "merchantsData.paymentDetail.createdAt": "Créé le",
  "merchantsData.paymentDetail.orderItems": "Articles de la commande",
  "merchantsData.paymentDetail.itemName": "Nom de l’article",
  "merchantsData.paymentDetail.quantity": "Quantité",
  "merchantsData.paymentDetail.price": "Prix",
  "merchantsData.paymentDetail.itemID": "ID de l’article",
  "merchantsData.paymentDetail.variation": "Variation",
  "merchantsData.paymentDetail.TotalMerchants":
    "Total des commerçants : {{number}}",

  "customerLoyalty.header": "Fidélité des clients",
  "customerLoyalty.totalPoints": "Points totaux :",
  "customerLoyalty.hidePurchaseHistory": "Masquer l’historique des achats",
  "customerLoyalty.showPurchaseHistory": "Afficher l’historique des achats",
  "customerLoyalty.paymentState": "État du paiement",
  "customerLoyalty.title": "Titre",
  "customerLoyalty.createdTime": "Date de création",
  "customerLoyalty.nodata": "Aucune donnée client trouvée",

  "validateRewards.header": "Toutes les récompenses",
  "validateRewards.selectMerchant": "Sélectionner un commerçant",
  "validateRewards.createReward": "Créer une récompense",
  "validateRewards.autoRefreshing": "Actualisation automatique toutes les 3 s",
  "validateRewards.loading": "Chargement...",
  "validateRewards.loadingRewards": "Chargement des récompenses...",
  "validateRewards.debugInfo": "Infos de débogage",
  "validateRewards.debugInformation": "Informations de débogage",
  "validateRewards.MerchantFound": "Commerçant trouvé",
  "validateRewards.BusinessName": "Nom de l’entreprise",
  "validateRewards.totalrewards": "Total des récompenses (tous statuts)",
  "validateRewards.statusBreakdown": "Répartition des statuts : En attente",
  "validateRewards.Validated": "Validé",
  "validateRewards.Redeemed": "Utilisé",
  "validateRewards.Expired": "Expiré",
  "validateRewards.TotalUserRewards": "Total des récompenses utilisateur",
  "validateRewards.message":
    "Les récompenses apparaîtront ici lorsque les clients les créeront ou les valideront.",
  "validateRewards.NoRewards": "Aucune récompense",
  "validateRewards.Customer": "Client",
  "validateRewards.Reward": "Récompense",
  "validateRewards.Points": "Points",
  "validateRewards.Created": "Créé",
  "validateRewards.ExpiresIn": "Expire dans",
  "validateRewards.Action": "Action",
  "validateRewards.Notimestamp": "Aucun horodatage",
  "validateRewards.Validate": "Valider",
  "validateRewards.Expire": "Expirer",
  "validateRewards.Redeeming": "Utilisation...",
  "validateRewards.Redeem": "Utiliser",
  "validateRewards.Pending": "En attente",
  "validateRewards.Awaitingvalidation": "En attente de validation",
  "validateRewards.Awaitingredemption": "En attente d’utilisation",
  "validateRewards.Completed": "Terminé",
  "validateRewards.Nolongervalid": "Plus valide",
  "validateRewards.CreateNewReward": "Créer une nouvelle récompense",
  "validateRewards.Optional": "Optionnel",
  "validateRewards.Loadingcustomers": "Chargement des clients...",
  "validateRewards.Selectcustomer":
    "Sélectionnez un client (ou laissez vide pour vous-même)...",
  "validateRewards.selectcustomers":
    "Sélectionnez un client ayant des récompenses avec ce commerçant. Laissez vide pour créer la récompense pour vous-même.",
  "validateRewards.RewardType": "Type de récompense",
  "validateRewards.Selectrewardtype": "Sélectionnez le type de récompense...",
  "validateRewards.FreeCoffee": "Café gratuit",
  "validateRewards.Off": "Remise",
  "validateRewards.FreeItem": "Article gratuit",
  "validateRewards.PercentageOff": "Pourcentage de remise",
  "validateRewards.PointsUsed": "Points utilisés",
  "validateRewards.pointsused":
    "Nombre de points utilisés pour obtenir cette récompense (défaut : 0)",
  "validateRewards.Cancel": "Annuler",
  "validateRewards.Creating": "Création...",

  "loyaltyView.header": "Paramètres de fidélité",
  "loyaltyView.Loadingsettings": "Chargement des paramètres...",
  "loyaltyView.PointsperDollar": "Points par dollar",
  "loyaltyView.MinimumOrderAmount": "Montant minimum de commande",
  "loyaltyView.PointsperOrder": "Points par commande",
  "loyaltyView.PointsperItem": "Points par article",
  "loyaltyView.BonusThreshold": "Seuil de bonus",
  "loyaltyView.BonusPoints": "Points bonus",
  "loyaltyView.Save": "Enregistrer",
  "loyaltyView.Edit": "Modifier",

  "newusers.header": "Utilisateurs inactifs",
  "newusers.Username": "Nom d’utilisateur",
  "newusers.Active": "Actif",

  "usersLists.header": "Utilisateurs",
  "usersLists.Options": "Options",
  "usersLists.Deactivate": "Désactiver",
  "usersLists.Delete": "Supprimer",

  "merchantApprovals.header": "Liste des commerçants en attentes",

  "adminKpis.title": "Tableau de bord KPI",
  "adminKpis.generatedAt": "Données au",
  "adminKpis.overview": "Indicateurs généraux",
  "adminKpis.userMetrics": "Indicateurs utilisateurs",
  "adminKpis.merchantBreakdown": "Répartition des commerçants",
  "adminKpis.loading": "Chargement des KPI…",
  "adminKpis.failedToLoad": "Impossible de charger le tableau de bord KPI.",
  "adminKpis.noMerchants": "Aucun commerçant trouvé.",
  "adminKpis.totalMerchants": "Total commerçants",
  "adminKpis.paid": "Payants",
  "adminKpis.trial": "Essai",
  "adminKpis.churned": "Résiliés",
  "adminKpis.totalLocations": "Total emplacements",
  "adminKpis.totalUsers": "Utilisateurs inscrits",
  "adminKpis.mrr": "MRR",
  "adminKpis.tapsAllTime": "Taps totaux (tout temps)",
  "adminKpis.tapsThisWeek": "Taps cette semaine",
  "adminKpis.tapsThisMonth": "Taps ce mois",
  "adminKpis.avgTapsPerMerchant": "Taps moy. / commerçant / mois",
  "adminKpis.trialToPaid": "Essai → payant (essais terminés)",
  "adminKpis.churnRate": "Taux de désabonnement (% payants résiliés)",
  "adminKpis.newUsersWeek": "Nouveaux utilisateurs (semaine)",
  "adminKpis.users2PlusVisits": "Utilisateurs avec 2+ visites",
  "adminKpis.usersActiveProgress": "Progression récompense active",
  "adminKpis.usersClaimedReward": "Ont réclamé ≥1 récompense",
  "adminKpis.colName": "Commerçant",
  "adminKpis.colLocation": "Emplacement",
  "adminKpis.colStatus": "Statut",
  "adminKpis.colTrialEnd": "Fin d'essai",
  "adminKpis.colTotalTaps": "Taps totaux",
  "adminKpis.colTaps7d": "Taps (7 j)",
  "adminKpis.colUniqueUsers": "Utilisateurs uniques",
  "adminKpis.colRewards": "Récompenses réclamées",
  "adminKpis.colLastTap": "Dernier tap",
  "adminKpis.status.paid": "Payant",
  "adminKpis.status.trial": "Essai",
  "adminKpis.status.churned": "Résilié",
  "adminKpis.status.other": "Autre",

  "businesses.header": "Entreprises",
  "businesses.Add": "Ajouter",
  "businesses.ID": "ID",
  "businesses.Name": "Nom",
  "businesses.Contact": "Contact",
  "businesses.Update": "Mettre à jour",

  "clients.header": "Clients",
  "clients.Age": "Âge",
  "clients.Address": "Adresse",
  "clients.Gender": "Genre",
  "clients.Business": "Entreprise",
  "clients.DOB": "Date de naissance",
  "clients.PurchaseDetails": "Détails d’achat",
  "clients.Details": "Détails",

  "itemsPurchased.header": "Articles achetés",
  "itemsPurchased.AddItemPurchased": "Ajouter un article acheté",
  "itemsPurchased.PurchaseHistoryID": "ID historique d’achat",
  "itemsPurchased.ItemName": "Nom de l’article",
  "itemsPurchased.Quantity": "Quantité",

  "purchaseHistory.header": "Historique des achats",
  "purchaseHistory.AddPurchase": "Ajouter un achat",
  "purchaseHistory.Client": "Client",
  "purchaseHistory.Date": "Date",
  "purchaseHistory.Time": "Heure",
  "purchaseHistory.TotalAmount": "Montant total",

  "receiptsHistory.header": "Historique des reçus",
  "receiptsHistory.AddReceipt": "Ajouter un reçu",
  "receiptsHistory.AccountNumber": "Numéro de compte",
  "receiptsHistory.TransactionDate": "Date de transaction",
  "receiptsHistory.Company": "Entreprise",
  "receiptsHistory.PaymentAmount": "Montant du paiement",
  "receiptsHistory.PaymentType": "Type de paiement",
  "receiptsHistory.Plan": "Forfait",

  "customerChurnRate.header": "Taux d’attrition des clients",
  "customerChurnRate.chartTitle": "Taux d’attrition des clients",

  "itemsSoldDetails.header": "Détails des articles vendus",
  "itemsSoldDetails.MostSoldItem": "Article le plus vendu",
  "itemsSoldDetails.LeastSoldItem": "Article le moins vendu",
  "itemsSoldDetails.MostBuyingAgeGroup": "Groupe d’âge acheteur principal",
  "itemsSoldDetails.chartTitle": "Achats par heure de la journée",
  "itemsSoldDetails.PurchasesbyHour": "Achats par heure",

  "nPSChart.header": "Score Net Promoter (NPS)",
  "nPSChart.Promoters": "Promoteurs",
  "nPSChart.Passives": "Passifs",
  "nPSChart.Detractors": "Détracteurs",
  "nPSChart.SurveyRespondents": "Répondants à l’enquête",
  "nPSChart.NumberofRespondents": "Nombre de répondants",
  "nPSChart.Respondents": "Répondants",
  "nPSChart.chartTitle": "Score Net Promoter : {{score}}",

  "increasedMarginChart.header": "Marge accrue (produits à forte valeur)",
  "increasedMarginChart.Products": "Produits",
  "increasedMarginChart.MarginContributionpercentage":
    "Contribution à la marge (%)",
  "increasedMarginChart.IncreasedMargin": "Marge accrue par produit",
  "increasedMarginChart.MarginContribution": "Contribution à la marge",

  "RepeatPurchaseRateGraph.header": "Taux d’achats répétés",
  "RepeatPurchaseRateGraph.RepeatClients": "Clients récurrents",
  "RepeatPurchaseRateGraph.SinglePurchaseClients": "Clients à achat unique",

  "home.punchCardRewards": "Vos récompenses par carte de fidélité",
  "home.programDescDefault": "Ajoutez une ou plusieurs récompenses. Chacune est enregistrée dans votre catalogue de commerçant.",
  "home.addFirstReward": "Ajoutez votre première récompense",
  "home.programDescNoRewards": "Créez une récompense que les clients peuvent gagner avec des visites.",
  "home.rewardsInCatalog_one": "{{count}} récompense dans votre catalogue.",
  "home.rewardsInCatalog_other": "{{count}} récompenses dans votre catalogue.",

  "home.merchantAdminView": "Commerçant (vue administrateur)",
  "home.selectMerchant": "Sélectionner un commerçant…",
  "home.visitsThisMonth": "Visites ce mois-ci",
  "home.uniqueCustomers": "Clients uniques",
  "home.rewardsRedeemed": "Récompenses échangées",
  "home.repeatRate": "Taux de retour",
  "home.googleReviewsGenerated": "Avis Google générés via Klerk",
  "home.googleReviewsTotal": "Total des demandes reçues",
  "home.googleReviewsApproved": "Total approuvées",
  "home.googleReviewsDeclined": "Total refusées",
  "home.oneVisitAway": "Clients à 1 visite d'une récompense",
  "home.twoVisitsAway": "Clients à 2 visites d'une récompense",
  "home.viewCustomers": "Voir les clients",
  "home.recentActivity": "Activité récente",
  "home.loading": "Chargement…",
  "home.noActivity": "Aucune activité pour l'instant. Les visites, points et échanges apparaîtront ici.",
  "home.viewAllActivity": "Voir toute l'activité",
  "home.yourRewardProgram": "Votre programme de récompenses",
  "home.catalogSynced": "Catalogue synchronisé",
  "home.notSavedYet": "Pas encore enregistré",
  "home.noRewardsYet": "Aucune récompense — utilisez « Ajouter une récompense » ci-dessous.",
  "home.reward": "Récompense",
  "home.visitsRequired": "Visites requises",
  "home.visits": "visites",
  "home.saving": "Enregistrement…",
  "home.save": "Enregistrer",
  "home.cancel": "Annuler",
  "home.edit": "Modifier",
  "home.removing": "Suppression…",
  "home.remove": "Supprimer",
  "home.customerSelections": "Sélections des clients",
  "home.customerSelectionsDesc": "Les récompenses choisies dans l'application apparaissent ici en attente. Choisissez un autre client et enregistrez pour réassigner.",
  "home.noPendingRedemptions": "Aucun échange en attente ou en cours.",
  "home.customer": "Client",
  "home.selectCustomer": "Sélectionner un client…",
  "home.currentPrefix": "Actuel : ",
  "home.adding": "Ajout en cours…",
  "home.addReward": "Ajouter une récompense",
  "home.enterRewardType": "Entrer le type de récompense",
  "home.close": "Fermer",
  "home.addAReward": "Ajouter une récompense",
  "home.nfcStand": "Borne NFC :",
  "home.nfcActive": "Active",
  "home.allActivity": "Toute l'activité",
  "home.noActivityModal": "Aucune activité pour l'instant. Les échanges de récompenses, visites synchronisées et points d'achats apparaîtront ici.",

  "loyaltySettings.merchantAdmin": "Commerçant (admin)",
  "loyaltySettings.selectMerchant": "Sélectionner un commerçant…",
  "loyaltySettings.loading": "Chargement…",
  "loyaltySettings.rewardType": "Type de récompense",
  "loyaltySettings.rewardTypePlaceholder": "Entrer le type de récompense",
  "loyaltySettings.visitsRequired": "Visites requises",
  "loyaltySettings.addReward": "Ajouter une récompense",
  "loyaltySettings.adding": "Ajout en cours…",

  "billing.subtitle": "Facturation de l'abonnement marchand Klerk.",

  "referral.description": "Invitez des commerçants et gagnez un mois gratuit après qu'ils ont terminé le processus d'intégration et souscrit.",
  "referral.loading": "Chargement des statistiques de parrainage...",
  "referral.yourLink": "Votre lien de parrainage",
  "referral.copyLink": "Copier le lien",
  "referral.shareEmail": "Partager par e-mail",
  "referral.shareX": "Partager sur X",
  "referral.shareLinkedIn": "Partager sur LinkedIn",
  "referral.copied": "Lien de parrainage copié",
  "referral.copyFailed": "Impossible de copier le lien",
  "referral.clicks": "Clics",
  "referral.referrals": "Parrainages",
  "referral.rewardsEarned": "Récompenses gagnées",
  "referral.alerts": "Alertes du tableau de bord",
  "referral.noAlerts": "Pas encore d'alertes.",

  "googleReviews.title": "Avis Google",
  "googleReviews.description": "Approuvez les demandes de visite bonus des clients qui ont laissé un avis Google.",
  "googleReviews.loading": "Chargement des demandes d'avis...",
  "googleReviews.failedToLoad": "Impossible de charger les demandes d'avis.",
  "googleReviews.noPending": "Aucune demande d'avis en attente.",
  "googleReviews.requestedOn": "Demandé le",
  "googleReviews.approve": "Approuver",
  "googleReviews.decline": "Refuser",
  "googleReviews.processing": "Traitement…",
  "googleReviews.approvedSuccess": "Avis approuvé — visite bonus ajoutée.",
  "googleReviews.declinedSuccess": "Demande d'avis refusée.",
  "googleReviews.actionFailed": "Impossible de mettre à jour la demande d'avis.",
  "googleReviews.pendingBadge": "{{count}} demandes d'avis en attente",

  "flashDeals.title": "Offres éclair",
  "flashDeals.description": "Publiez une promotion à durée limitée que vos clients peuvent réclamer dans l'application Klerk.",
  "flashDeals.newDeal": "Nouvelle offre éclair",
  "flashDeals.item": "Article",
  "flashDeals.itemPlaceholder": "ex. Grand café latte",
  "flashDeals.deal": "Offre",
  "flashDeals.dealPlaceholder": "ex. 20 % de réduction, ou un achat donne un gratuit",
  "flashDeals.validFor": "Valide pendant",
  "flashDeals.days": "{{count}} jour",
  "flashDeals.days_plural": "{{count}} jours",
  "flashDeals.uploadPhoto": "Télécharger une photo",
  "flashDeals.uploading": "Téléchargement…",
  "flashDeals.uploadFailed": "Impossible de télécharger la photo. Veuillez réessayer.",
  "flashDeals.imageAlt": "Offre éclair",
  "flashDeals.remove": "Retirer",
  "flashDeals.publish": "Publier",
  "flashDeals.publishing": "Publication…",
  "flashDeals.posted": "Votre offre éclair a été publiée.",
  "flashDeals.postFailed": "Une erreur est survenue. Veuillez réessayer.",
  "flashDeals.missingMerchant": "Impossible de déterminer votre compte commerçant. Veuillez rafraîchir la page et réessayer.",
  "flashDeals.loading": "Chargement des offres éclair…",
  "flashDeals.loadFailed": "Impossible de charger les offres éclair.",
  "flashDeals.noDeals": "Aucune offre éclair pour le moment. Publiez votre première promotion !",
  "flashDeals.expired": "Expirée",
  "flashDeals.expiresIn": "Expire dans {{count}} jour",
  "flashDeals.expiresIn_plural": "Expire dans {{count}} jours",
  "flashDeals.delete": "Supprimer",
  "flashDeals.deleting": "Suppression…",
  "flashDeals.confirmDelete": "Supprimer cette offre éclair ? Cette action est irréversible.",
  "flashDeals.deleteFailed": "Impossible de supprimer l'offre éclair. Veuillez réessayer.",

  "customers.lead": "Téléphone, ID de fidélité, visites et points nécessaires pour la prochaine récompense, échanges et dernière activité — synchronisés depuis votre application de fidélité.",
  "customers.merchantAdmin": "Commerçant (admin)",
  "customers.chooseStore": "Choisissez la liste de clients de la boutique à afficher.",
  "customers.selectMerchant": "Sélectionner un commerçant…",
  "customers.selectFirst": "Sélectionnez un commerçant pour voir les clients.",
  "customers.noCustomers": "Aucun client pour l'instant. Quand des acheteurs tapent à votre emplacement ou synchronisent l'application, ils apparaîtront ici.",
  "customers.sortLastVisit": "Trier : Dernière visite",
  "customers.sortClosestReward": "Trier : Plus proche de la récompense",
  "customers.details": "Détails",

  "profile.title": "Profil du commerçant",
  "profile.active": "Actif",
  "profile.logOut": "Se déconnecter",
  "profile.editProfile": "Modifier le profil",
  "profile.saveChanges": "Enregistrer les modifications",
  "profile.saving": "Enregistrement...",
  "profile.cancel": "Annuler",
  "profile.businessInformation": "Informations sur l'entreprise",
  "profile.languagePreference": "Préférence de langue",
  "profile.cookieSettings": "Paramètres des cookies",
  "profile.deleteAccount": "Supprimer le compte",
  "profile.accountEmail": "Email du compte",
  "profile.businessName": "Nom de l'entreprise",
  "profile.address": "Adresse",
  "profile.category": "Catégorie",
  "profile.phone": "Téléphone",
  "profile.notProvided": "Non fourni",
  "profile.enterBusinessName": "Entrer le nom de l'entreprise",
  "profile.enterAddress": "Entrer l'adresse de l'entreprise",
  "profile.selectCategory": "Sélectionner une catégorie",
  "profile.enterPhone": "Entrer le numéro de téléphone",
  "profile.emailLoginNote": "Votre email de compte (utilisé pour la connexion)",
  "profile.displayLanguage": "Langue d'affichage",
  "profile.chooseLanguage": "Choisissez votre langue préférée",
  "profile.language": "Langue",
  "profile.manageCookies": "Gérez vos préférences de cookies",
  "profile.deleteAccountQuestion": "Êtes-vous sûr de vouloir supprimer votre compte ?",
  "profile.deleting": "Suppression en cours...",
  "profile.loadingProfile": "Chargement du profil du commerçant...",
  "profile.noBusinessFound": "Aucun profil d'entreprise trouvé. Veuillez d'abord compléter l'assistant d'intégration.",
  "profile.failedToLoad": "Échec du chargement du profil. Veuillez réessayer.",
  "profile.failedToSave": "Échec de l'enregistrement du profil. Veuillez réessayer.",
  "profile.requiredFields": "Le nom, l'adresse, la catégorie et le téléphone sont obligatoires.",
  "profile.updateSuccess": "Profil mis à jour avec succès !",
  "profile.loggedOut": "Vous avez été déconnecté avec succès.",
  "profile.deleteConfirm": "Cela supprimera définitivement votre compte. Voulez-vous continuer ?",
  "profile.failedToDelete": "Échec de la suppression du compte. Veuillez réessayer.",
  "profile.googlePlaceId": "Identifiant Google Place",
  "profile.googlePlaceIdPlaceholder": "Collez votre identifiant Google Place",
  "profile.googlePlaceIdHint": "Active l'invitation à laisser un avis Google sur votre formulaire client.",
  "profile.freeVisitForReview": "Offrir une visite gratuite aux clients qui laissent un avis Google",
  "profile.yes": "Oui",
  "profile.no": "Non",

  "squareLogin.buttonTitle": "Se connecter avec Square",

  "login.header": "Connexion",
  "login.createAccount": "Vous n'avez pas de compte ? Créez votre compte",
  "login.text": "Texte",
  "login.password": "Mot de passe",
  "login.ForgotPassword": "Mot de passe oublié?",
  "login.Signup": "S'inscrire",
  "login.signupwith": "Ou inscrivez-vous avec",
  "login.WelcomeBack": "Bon retour !",
  "login.clickingsignupbutton":
    "Créez simplement votre compte en cliquant sur le bouton d'inscription !",

  "onboarding.step": "Étape {{step}} sur {{total}}",
  "onboarding.screen0.title": "Créez votre compte commerçant",
  "onboarding.screen0.email": "Courriel",
  "onboarding.screen0.password": "Mot de passe",
  "onboarding.screen0.passwordPlaceholder": "Min 8 caractères avec majuscule, minuscule, chiffre et symbole",
  "onboarding.screen0.weak": "Faible",
  "onboarding.screen0.fair": "Moyen",
  "onboarding.screen0.strong": "Fort",
  "onboarding.screen0.req1": "✓ Au moins 8 caractères",
  "onboarding.screen0.req2": "✓ Majuscules et minuscules",
  "onboarding.screen0.req3": "✓ Un chiffre",
  "onboarding.screen0.req4": "✓ Un symbole (ex. ! @ # $)",
  "onboarding.screen0.terms": "En continuant, vous acceptez nos",
  "onboarding.screen0.termsLink": "Conditions d'utilisation",
  "onboarding.screen0.and": "et notre",
  "onboarding.screen0.privacyLink": "Politique de confidentialité",
  "onboarding.screen0.invalidEmail": "Entrez un courriel valide pour continuer.",
  "onboarding.screen0.passwordWeak": "Complétez toutes les exigences du mot de passe pour continuer.",
  "onboarding.screen0.creating": "Création du compte...",
  "onboarding.screen0.continue": "Continuer",
  "onboarding.screen0.backToLogin": "Vous avez déjà un compte ? Retour à la connexion →",
  "onboarding.screen1.title": "Parlez-nous de votre entreprise",
  "onboarding.screen1.titleEdit": "Modifier les informations de votre entreprise",
  "onboarding.screen1.subtitle": "Cela nous aide à personnaliser votre expérience.",
  "onboarding.screen1.subtitleEdit": "Mettez à jour vos informations ci-dessous.",
  "onboarding.screen1.businessName": "Nom de l'entreprise",
  "onboarding.screen1.businessNamePlaceholder": "ex. Café Soleil",
  "onboarding.screen1.address": "Adresse de l'entreprise",
  "onboarding.screen1.addressPlaceholder": "Commencez à taper votre adresse...",
  "onboarding.screen1.addressTip": "💡 Conseil : Notre équipe intégrera la saisie automatique Google Places ici",
  "onboarding.screen1.category": "Catégorie",
  "onboarding.screen1.selectCategory": "Sélectionnez une catégorie",
  "onboarding.screen1.phone": "Téléphone de l'entreprise",
  "onboarding.screen1.phonePlaceholder": "+1 (555) 000-0000",
  "onboarding.screen1.googlePlaceId": "Identifiant Google Place",
  "onboarding.screen1.googlePlaceIdPlaceholder": "Collez votre identifiant Google Place",
  "onboarding.screen1.googlePlaceIdHint": "Active l'invitation à laisser un avis Google sur votre formulaire client.",
  "onboarding.screen1.freeVisitForReview": "Offrir une visite gratuite aux clients qui laissent un avis Google",
  "onboarding.screen2.title": "Créez votre carte de fidélité numérique",
  "onboarding.screen2.titleEdit": "Modifier votre carte de fidélité numérique",
  "onboarding.screen2.subtitle": "Définissez la récompense que vos clients adoreront.",
  "onboarding.screen2.subtitleEdit": "Mettez à jour vos paramètres de récompense ci-dessous.",
  "onboarding.screen2.buy": "Achetez",
  "onboarding.screen2.visits": "visites → Obtenez",
  "onboarding.screen2.visitsLabel": "Nombre de visites requises",
  "onboarding.screen2.rewardDesc": "Description de la récompense",
  "onboarding.screen2.rewardDescPlaceholder": "ex. 1 article gratuit",
  "onboarding.screen2.rewardType": "Type de récompense",
  "onboarding.screen2.rewardTypePlaceholder": "ex. Article gratuit, Café gratuit, 10% de remise",
  "onboarding.screen3.title": "Commencez votre essai gratuit de 30 jours",
  "onboarding.screen3.subtitle": "Aucun frais aujourd'hui. Annulez à tout moment.",
  "onboarding.screen3.stripeSecure": "Paiement sécurisé par Stripe",
  "onboarding.screen3.enterPayment": "Entrer les informations de paiement",
  "onboarding.screen3.loading": "Chargement...",
  "onboarding.screen3.mockHint": "API de test - sera connecté au vrai Stripe plus tard",
  "onboarding.screen3.creatingSession": "Création de la session de paiement...",
  "onboarding.screen4.title": "Votre carte de fidélité est en ligne !",
  "onboarding.screen4.titleEdit": "Vos modifications sont enregistrées !",
  "onboarding.screen4.subtitle": "Voici ce qui est configuré pour",
  "onboarding.screen4.subtitleEdit": "Voici ce qui a été mis à jour pour",
  "onboarding.screen4.reward": "Récompense",
  "onboarding.screen4.buy": "Achetez",
  "onboarding.screen4.get": "→ Obtenez",
  "onboarding.screen4.type": "Type",
  "onboarding.screen4.businessId": "ID de l'entreprise",
  "onboarding.screen4.nfcStand": "Borne NFC",
  "onboarding.screen4.nfcDelivery": "Livraison sous 24 heures",
  "onboarding.screen4.checklist": "Liste de démarrage",
  "onboarding.screen4.check1": "Placez votre borne NFC",
  "onboarding.screen4.check2": "Dites à votre personnel : « Tapez pour gagner des points. »",
  "onboarding.screen4.check3": "Faites taper vos 10 premiers clients",
  "onboarding.screen4.goToDashboard": "Aller au tableau de bord →",
  "onboarding.screen4.backToProfile": "Retour au profil →",
  "onboarding.back": "Retour",
  "onboarding.next": "Suivant",
  "onboarding.saving": "Enregistrement...",

  "forgotPassword.header": "Mot de passe oublié",
  "forgotPassword.subtext": "Entrez votre courriel professionnel et nous vous enverrons un lien de réinitialisation.",
  "forgotPassword.placeholder": "Entrez votre courriel",
  "forgotPassword.sendLink": "Envoyer le lien de réinitialisation",
  "forgotPassword.backToLogin": "Retour à la connexion",
  "forgotPassword.rightTitle": "Déjà un compte ?",
  "forgotPassword.rightText": "Connectez-vous pour continuer.",
  "forgotPassword.successMsg": "Courriel de réinitialisation envoyé ! Vérifiez votre boîte de réception.",
  "forgotPassword.errorMsg": "Échec de l'envoi du courriel. Veuillez réessayer.",

  "resetPassword.header": "Réinitialiser le mot de passe",
  "resetPassword.newPassword": "Nouveau mot de passe",
  "resetPassword.confirmPassword": "Confirmer le nouveau mot de passe",
  "resetPassword.submit": "Réinitialiser le mot de passe",
  "resetPassword.backToLogin": "Retour à la connexion",
  "resetPassword.rightTitle": "Déjà un compte ?",
  "resetPassword.invalidLink": "Lien de réinitialisation invalide. Veuillez en demander un nouveau.",
  "resetPassword.mismatch": "Les mots de passe ne correspondent pas.",
  "resetPassword.success": "Mot de passe réinitialisé avec succès ! Vous pouvez maintenant vous connecter.",
  "resetPassword.error": "Échec de la réinitialisation. Le lien a peut-être expiré. Veuillez en demander un nouveau.",
  "resetPassword.subtext": "Choisissez un nouveau mot de passe pour votre compte.",
  "resetPassword.rightText": "Connectez-vous pour continuer.",
  // customers
  "customers.phone": "Téléphone",
  "customers.loyaltyId": "ID de fidélité",
  "customers.visitsToNext": "Visites avant la prochaine récompense",
  "customers.rewardsRedeemed": "Récompenses échangées",
  "customers.lastVisit": "Dernière visite",
  "customers.count_one": "{{count}} client",
  "customers.count_other": "{{count}} clients",
  "customers.defaultStore": "Boutique",

  "billing.yourSubscription": "Votre abonnement",
  "billing.status": "Statut",
  "billing.currentPlan": "Forfait actuel",
  "billing.nextBillingDate": "Prochaine date de facturation",
  "billing.firstCharge": "Premier prélèvement (après l'essai)",
  "billing.manageBilling": "Gérer la facturation",
  "billing.opening": "Ouverture…",
  "billing.redirecting": "Redirection…",
  "billing.stripeHint": "Ouvre le portail Stripe pour mettre à jour la carte, voir les factures ou annuler.",
  "billing.noSubscription": "Aucun abonnement actif",
  "billing.statusActive": "Actif",
  "billing.statusTrial": "Actif · Essai gratuit",
  "billing.statusPastDue": "Paiement en retard",
  "billing.statusCanceled": "Annulé",
  "billing.statusUnpaid": "Impayé",
  "billing.trialLabel": "· essai gratuit",
  "billing.loadingStore": "Chargement de votre boutique…",
  "billing.finishSetup": "Terminez la configuration de votre entreprise pour accéder à la facturation et démarrer votre essai gratuit.",
  "billing.completeSetup": "Terminer la configuration",
  "billing.enterEmail": "Entrez l'adresse courriel de votre compte pour connecter votre abonnement Stripe.",
  "billing.emailLabel": "Courriel de facturation",
  "billing.emailPlaceholder": "vous@exemple.com",
  "billing.checkoutSuccess": "Votre abonnement est actif. Les détails de l'essai et la date du premier prélèvement sont ci-dessous.",
  "billing.checkoutWarn": "Si la gestion de la facturation échoue encore, confirmez que vous êtes connecté avec le même courriel utilisé dans Stripe.",
  "billing.yourStore": "Votre boutique",
  "billing.defaultPlan": "Votre forfait",
  "billing.klerkSubscription": "Abonnement Klerk",
  "validateRewards.confirmExpire": "Êtes-vous sûr de vouloir expirer cette récompense ?",

  "customers.modal.title": "Détails du client",
  "customers.modal.phone": "Téléphone",
  "customers.modal.loyaltyId": "ID de fidélité",
  "customers.modal.visitCount": "Nombre de visites",
  "customers.modal.visitsToNext": "Visites avant la prochaine récompense",
  "customers.modal.totalRedeemed": "Total des récompenses échangées",
  "customers.modal.lastVisit": "Dernière visite",
  "customers.modal.lastRedemption": "Dernier échange",
  "customers.modal.redemptionHistory": "Historique des échanges",
  "customers.modal.redemptionDesc": "Totaux depuis l'application du client : combien de récompenses utilisées et quand la dernière a été réclamée.",
  "customers.modal.lifetimeRedemptions": "Échanges au total :",
  "customers.modal.lastRewardClaimed": "Dernière récompense réclamée le :",
  "customers.modal.noRedemptionHistory": "Aucun historique d'échange pour cette boutique.",
  "customers.modal.recentActivity": "Activité récente",
  "customers.modal.noActivity": "Aucune visite ou tap récent à afficher.",
  "customers.modal.when": "Quand",
  "customers.modal.type": "Type",
  "customers.modal.notes": "Notes",
  "customers.modal.recorded": "Enregistré",
  "customers.modal.redemptionRelated": "Lié à un échange",
  "customers.modal.visitOther": "Visite / autre",
  "customers.modal.close": "Fermer",

  "clients.deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce client ?",

  "home.removeConfirm": "Supprimer cette récompense de votre programme ?",

  "usersLists.deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
};

export default fr;
